import type { StorageSerializer } from "./storage"
import { localStorageStrategy, useStorage } from "./storage"

type JsonPrimitive = string | number | boolean
type JsonValue = JsonPrimitive | JsonPrimitive[] | Record<string, JsonPrimitive>

/**
 * Like useState, but persists the state to localStorage.
 * See `useCookie` to store values in a cookie instead.
 *
 * @param key Unique name
 * @param initialValue An optional value to use if the value is not found in localStorage
 * @param serializer An optional serializer to use for the value. Defaults to `JSON.parse and stringify`
 */
export function useLocalState<T extends JsonValue>(
  key: string,
  initialValue: T,
  serializer?: StorageSerializer<T>
): [T, (value: T | ((val: T) => T)) => void] {
  return useStorage(localStorageStrategy, key, initialValue, {
    sync: true,
    serializer,
  })
}
